import { GetProjectForm } from "../../../modules/form/GetProjectForm";
import { hideModal, showModal } from "./modalFunctions";
/**
 * @description Class that manages the storage of UTM parameters in sessionStorage.
 */
export class loadDataAVI {
    constructor(formState) {
        this.formState = formState;
        this.projectForm = new GetProjectForm(formState);
        this.loadAVIChat = this.loadAVIChat.bind(this);
    }
    getAVIParams() {
        const urlParams = new URLSearchParams(window.location.search);
        return {
            name: urlParams.get('name') || '',
            lastName: urlParams.get('lastname') || '',
            phone: urlParams.get('phone') || '',
            email: urlParams.get('email') || '',
            destination: urlParams.get('destination') || '',
            utmCampaign: urlParams.get('utm_campaign') || '',
        };
    }
    isAVI() {
        const { name, lastName, phone, email, utmCampaign, } = this.getAVIParams();
        return (utmCampaign === 'AVI' && name !== '' && phone !== '' && email !== '');
    }
    /**
    * Method that saves the parameters to sessionStorage if they are not already stored.
    * Extracts the parameters from the current URL and saves them in sessionStorage for later use.
    */
    saveDataParams() {
        sessionStorage.removeItem('medio_contact');
        const { name, lastName, phone, email, destination, } = this.getAVIParams();
        if (this.isAVI()) {
            showModal('aviModal');
            const formName = this.formState.manageState('formName') || '#modalContacto';
            const form = document.querySelector(formName);
            form.querySelector('[name="name"]').value = name;
            form.querySelector('[name="lastname"]').value = lastName;
            form.querySelector('[name="email"]').value = email;
            form.querySelector('[name="phone"]').value = phone;
            form.querySelector('[name="habitar_invertir"]').value = destination;
            const destinationInput = form.querySelector(`[name="habitar_invertir"][value="${destination}"]`);
            if (destinationInput) {
                destinationInput.checked = true;
            }
        }
    }
    saveContactMedium() {
        const isChecked = document.querySelector('[name="medio_contacto"]:checked');
        if (!isChecked) {
            const aviError = document.getElementById('error-avi');
            aviError === null || aviError === void 0 ? void 0 : aviError.classList.add('d-block');
            return;
        }
        sessionStorage.setItem('medio_contact', isChecked.value);
        setTimeout(() => {
            hideModal('aviModal');
        }, 300);
    }
    loadAVIChat(nid) {
        var _a;
        const aviWrapper = document.getElementById('avi-fab-wrapper');
        aviWrapper === null || aviWrapper === void 0 ? void 0 : aviWrapper.classList.add('show-result');
        (_a = window.toggleAviChat) === null || _a === void 0 ? void 0 : _a.call(window, nid);
    }
    setFilters(fieldsData, data_select) {
        var _a, _b, _c, _d, _e;
        try {
            const rawMin = (_a = data_select['price']) === null || _a === void 0 ? void 0 : _a[0];
            const rawMax = (_b = data_select['price']) === null || _b === void 0 ? void 0 : _b[1];
            const minPrice = (rawMin !== undefined && rawMin !== null && rawMin !== '') ? rawMin : '';
            const maxPrice = (rawMax !== undefined && rawMax !== null && rawMax !== '') ? rawMax : '';
            let budgetText = '';
            if (minPrice !== '' && maxPrice !== '') {
                if (Number(minPrice) === 0) {
                    budgetText = ` hasta $${Number(maxPrice).toLocaleString()}`;
                }
                else {
                    budgetText = ` $${Number(minPrice).toLocaleString()} a $${Number(maxPrice).toLocaleString()}`;
                }
            }
            else if (maxPrice !== '') {
                budgetText = ` hasta $${Number(maxPrice).toLocaleString()}`;
            }
            else if (minPrice !== '') {
                budgetText = ` $${Number(minPrice).toLocaleString()}`;
            }
            const currentFilters = {
                city: ((_c = fieldsData['cities']) === null || _c === void 0 ? void 0 : _c.value) || '',
                zone: ((_d = fieldsData['zone']) === null || _d === void 0 ? void 0 : _d.value) || '',
                sector: ((_e = fieldsData['sector']) === null || _e === void 0 ? void 0 : _e.value) || '',
                budget: budgetText,
                origin: 'AVI - Resultados',
            };
            const floatIframe = document.getElementById("avi-chat-float-frame");
            if (floatIframe === null || floatIframe === void 0 ? void 0 : floatIframe.contentWindow) {
                floatIframe.contentWindow.postMessage({
                    type: "AVI_FILTER_UPDATE",
                    payload: currentFilters,
                }, "*");
            }
        }
        catch (e) {
            console.warn("Error updating AVI filters:", e);
        }
    }
}
